import React, { Fragment, useState } from 'react';
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import Collapse from "@material-ui/core/Collapse";
import { Link }  from "react-router-dom";
import './style.css';

const menus = [
    {
        id: 1,
        title: 'Home',
        link: '/',
    
    },

{
    id: 2,
        title: 'About',
        link: '/about',
    
    },
{
    id: 4,
        title: 'Photography',
        link: '/portfolio-photo',
        // submenu: [
        //     {
        //         id: 41,
        //         title: 'Portfolio Grid',
        //         link: '/portfolio-grid'
        //     },
        //     {
        //         id: 42,
        //         title: 'Portfolio Masonary',
        //         link: '/portfolio-masonary'
        //     },
        //     {
        //         id: 43,
        //         title: 'Portfolio Masonary S2',
        //         link: '/portfolio-masonary-s2'
        //     },
        //     {
        //         id: 45,
        //         title: 'Portfolio Masonary S3',
        //         link: '/portfolio-masonary-s3'
        //     },
        //     {
        //         id: 44,
        //         title: 'Portfolio Single',
        //         link: '/project-single/1'
        //     }
        // ]
    },

    {
        id: 7,
        title: 'Films',
        link: '/hotc-films',
    
    },
    {
        id: 8,
        title: 'Testimonial',
        link: '/Testimonial',
    },


    {
        id: 88,
        title: 'Inquiry',
        link: '/inquiry1',
    },
    {
        id: 82,
            title: 'More',
            link: '#',
            submenu: [
                {
                    id: 41,
                    title: 'Careers',
                    link: '/careers'
                },
                {
                    id: 42,
                    title: 'Travel',
                    link: '/travel'
                },
                {
                    id: 43,
                    title: 'Backyard',
                    link: '/backyard'
                },
                {
                    id:48,
                    title:'Editorial',
                    link:'/editorial'
                                                                      
                    
                }
              
            ]
        },
    
]


const MobileMenu = () => {

    const [openId, setOpenId] = useState(0);
    const [menuActive, setMenuState] = useState(false);

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    return (
        <div>
            <div className={`mobileMenu ${menuActive ? "show" : ""}`}>
                <div className="menu-close">
                    <div className="clox" onClick={() => setMenuState(!menuActive)}><i className="ti-close"></i></div>
                </div>

                <ul className="responsivemenu">
                    {menus.map((item, mn) => {
                        return (
                            <ListItem className={item.id === openId ? 'active' : null}  key={mn}>
                                {item.submenu ?
                                    <Fragment>
                                        <p onClick={() => setOpenId(item.id === openId ? 0 : item.id)}>{item.title}
                                          <i className={item.id === openId ? 'fa fa-angle-up' : 'fa fa-angle-down'}></i>
                                        </p>
                                        <Collapse in={item.id === openId} timeout="auto" unmountOnExit>
                                            <List className="subMenu">
                                                <Fragment>
                                                    {item.submenu.map((submenu, i) => {
                                                        return (
                                                            <ListItem key={i}>
                                                                <Link onClick={ClickHandler}
                                                                    to={submenu.link}>{submenu.title}</Link>
                                                            </ListItem>
                                                        )
                                                    })}
                                                </Fragment>
                                            </List>
                                        </Collapse>
                                    </Fragment>
                                    : <Link
                                        to={item.link}>{item.title}</Link>
                                }
                            </ListItem>
                        )
                    })}
                </ul>

            </div>

            <div className="showmenu" onClick={() => setMenuState(!menuActive)}>
                <button type="button" className="navbar-toggler open-btn">
                    <span className="icon-bar first-angle"></span>
                    <span className="icon-bar middle-angle"></span>
                    <span className="icon-bar last-angle"></span>
                </button>
            </div>
        </div>
    )
}

export default MobileMenu;